import React from "react";
import styled from "styled-components";
import type { PaymentIconInternalProps } from "./types";

const StyledPaymentIcon = styled.div<{ $size: number }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${(props) => Math.round(props.$size * (4 / 3))}px;
  height: ${(props) => props.$size}px;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const PaymentIcon: React.FC<PaymentIconInternalProps> = ({
  size = 18,
  svgContent,
  className,
  style,
  "data-testid": testId,
  testID,
  "aria-label": ariaLabel,
  "aria-hidden": ariaHidden,
}) => (
  <StyledPaymentIcon
    $size={size}
    className={className}
    style={style}
    data-testid={testId || testID}
    role={ariaLabel ? "img" : undefined}
    aria-label={ariaLabel}
    aria-hidden={ariaHidden ?? (ariaLabel ? undefined : true)}
    dangerouslySetInnerHTML={{ __html: svgContent }}
  />
);
